import { __ } from "@wordpress/i18n";
import { useMemo } from "@wordpress/element";
import SearchAnalytics from "./analytics";
import { SearchQueries } from "./queries";
import { css } from "@/utils/css";
import { useRoute } from "@/hooks/use-route";
import { Tabs } from "@/components/tabs";
import { useSearchQueries } from "@/hooks/use-search-queries";

export default function AISearch() {
    const { navigate, query } = useRoute();
    const { data: searchQueriesData } = useSearchQueries();

    const tabs = [
        {
            value: "analytics",
            label: __("Analytics", "antimanual"),
            title: __("AI Search Analytics", "antimanual"),
            description: __("Monitor the performance and usage of your AI Search blocks across your website.", "antimanual"),
            element: <SearchAnalytics />,
        },
        {
            value: "search-queries",
            title: __("Search Queries", "antimanual"),
            label: __("Search Queries", "antimanual") + ` (${searchQueriesData?.total || 0})`,
            description: __("View and manage all search queries from the AI Search block.", "antimanual"),
            element: <SearchQueries />,
        },
    ];

    const activeTab = useMemo(() => tabs.find((sect) => sect.value === query.tab) || tabs[0], [query.tab, searchQueriesData]);

    return (
        <div className={css("ai-search")}>
            <Tabs 
                standalone 
                tabs={tabs} 
                activeTab={activeTab.value} 
                onTabChange={(value) => navigate(`?page=${query.page}&tab=${value}`)} 
            />
            <div className={css("pb-5 pt-2 px-2")}>
                <h2>{activeTab.title}</h2>
                <p>{activeTab.description || ""}</p>
            </div>
            <div className={css("panel")}>
                {activeTab.element}
            </div>
        </div>
    );
}
